// extracted by mini-css-extract-plugin
export var button = "_o3-0";